(function () {
  'use strict';

  function whenIdle(fn) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 50);
    }
  }

  // Karten jenseits der Spaltenzahl stecken serverseitig in einem template.
  // Template-Inhalt wird zwar geparst, aber nicht gestylt und nicht gelayoutet,
  // und Skripte darin laufen nicht. Genau diese Style- und Layout-Arbeit soll
  // aus dem kritischen Fenster heraus.
  //
  // Bewusst einzeln und je in einer Leerlaufphase: alle auf einmal einzuhaengen
  // wuerde die Blockade nur verschieben statt sie zu zerlegen.
  function hydrateCards(root, done) {
    var scope = root || document;
    var templates = Array.prototype.slice.call(scope.querySelectorAll('template[data-deferred-card]'));

    if (!templates.length) {
      if (done) done();
      return;
    }

    function next() {
      var tpl = templates.shift();

      if (!tpl) {
        if (done) done();
        return;
      }

      // Kann passieren, wenn die Sektion zwischenzeitlich ersetzt wurde
      if (!tpl.isConnected || !tpl.parentNode) {
        next();
        return;
      }

      try {
        var frag = document.importNode(tpl.content, true);
        var inserted = Array.prototype.slice.call(frag.children);
        tpl.parentNode.insertBefore(frag, tpl);
        tpl.remove();

        // Die Hover-Zweitbilder stecken ihrerseits in einem template. Der globale
        // Handler in theme.liquid loest die nur einmal beim load-Event auf und
        // sieht dabei nicht in Template-Inhalte hinein. Ohne diesen Schritt
        // blieben sie auf nachtraeglich aktivierten Karten fuer immer verborgen.
        // Nur mit Zeigegeraet: ohne Hover bliebe das Zweitbild ungesehen und
        // waere reine Datenlast. Gleiche Bedingung wie in theme.liquid und
        // deferred-sections.js.
        if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          inserted.forEach(function (el) {
            if (!el.querySelectorAll) return;
            el.querySelectorAll('template.deferred-secondary-img').forEach(function (t) {
              t.replaceWith(t.content);
            });
          });
        }
      } catch (e) {
        console.warn('[DeferredCards] Aktivierung fehlgeschlagen', e);
      }

      whenIdle(next);
    }

    whenIdle(next);
  }

  // Mitte des Bildes einer bestimmten Folie, gemessen ab Oberkante des
  // slider-component. Ueber die tatsaechlichen Rechtecke, nicht ueber
  // offsetHeight: .grid__item hat oben 0.75rem Polsterung fuer den
  // Hover-Effekt, das Bild beginnt also nicht buendig an der Oberkante.
  function mediaCenter(slide, comp) {
    var media = slide.querySelector('.card__inner, .card__media');
    if (!media || !media.getBoundingClientRect || !comp.getBoundingClientRect) return null;

    var m = media.getBoundingClientRect();
    var c = comp.getBoundingClientRect();

    if (m.height) return Math.round(m.top - c.top + m.height / 2);

    // Rueckfall fuer Umgebungen ohne belastbare Rechtecke
    if (media.offsetHeight) return Math.round(media.offsetHeight / 2);
    return null;
  }

  // Jeder Pfeil wird auf der Karte ausgerichtet, auf der er tatsaechlich liegt:
  // der linke auf der ersten sichtbaren Folie, der rechte auf der letzten.
  // Bei image_ratio "adapt" sind die Bilder unterschiedlich hoch - eine einzige
  // gemeinsame Hoehe liess den rechten Pfeil sonst zu tief sitzen.
  function positionArrows(root) {
    var scope = root || document;
    var components = Array.prototype.slice.call(scope.querySelectorAll('slider-component'));

    // Wenn die Sektion selbst das slider-component ist, wird sie von
    // querySelectorAll nicht erfasst - deshalb zusaetzlich pruefen.
    if (scope.matches && scope.matches('slider-component')) components.push(scope);

    components.forEach(function (comp) {
      var prev = comp.querySelector('.slider-edge-arrow--prev');
      var next = comp.querySelector('.slider-edge-arrow--next');
      if (!prev && !next) return;

      var scroller = comp.querySelector('.slider');
      if (!scroller) return;

      var slides = Array.prototype.slice.call(comp.querySelectorAll('.slider__slide')).filter(
        function (s) {
          return s.clientWidth > 0;
        }
      );
      if (!slides.length) return;

      var sRect = scroller.getBoundingClientRect();
      var firstVisible = null;
      var lastVisible = null;

      slides.forEach(function (slide) {
        var r = slide.getBoundingClientRect();
        // 1px Toleranz, damit ein exakt an der Kante endender Slide nicht zaehlt
        if (r.right > sRect.left + 1 && r.left < sRect.right - 1) {
          if (!firstVisible) firstVisible = slide;
          lastVisible = slide;
        }
      });

      if (!firstVisible) firstVisible = slides[0];
      if (!lastVisible) lastVisible = slides[slides.length - 1];

      if (prev) {
        var pTop = mediaCenter(firstVisible, comp);
        if (pTop) prev.style.setProperty('--edge-arrow-top', pTop + 'px');
      }
      if (next) {
        var nTop = mediaCenter(lastVisible, comp);
        if (nTop) next.style.setProperty('--edge-arrow-top', nTop + 'px');
      }

      // Beim Scrollen wechseln die Randfolien, dann muss neu gemessen werden.
      if (!comp.__edgeArrowScrollBound) {
        comp.__edgeArrowScrollBound = true;
        var ticking = false;
        scroller.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            (window.requestAnimationFrame || setTimeout)(function () {
              ticking = false;
              positionArrows(comp);
            });
          },
          { passive: true }
        );
      }
    });
  }

  // Wird auch von deferred-sections.js aufgerufen, sobald eine nachgeladene
  // Sektion im DOM haengt.
  window.hydrateDeferredCards = function (root) {
    positionArrows(root);
    hydrateCards(root, function () {
      positionArrows(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.hydrateDeferredCards();
    });
  } else {
    window.hydrateDeferredCards();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      positionArrows();
    }, 150);
  });
})();
